import createMyTheme from './create-theme'
import { palette } from './pallete'

export const theme = createMyTheme({
  typography: {
    fontFamily: 'SofiaPro'
  },
  palette,
  overrides: {
    MuiPopover: {
      paper: {
        borderRadius: 8
      }
    },
    MuiCssBaseline: {
      '@global': {
        fontFamily: 'SofiaPro',
        '#root': {
          minWidth: '100%',
          minHeight: '100vh',
          fontFamily: 'SofiaPro'
        },
        html: {
          position: 'relative',
          minWidth: '100%',
          minHeight: '100vh',
          margin: 0,
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: 7
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'linear-gradient(180deg,#24b3f7,#2166a4)',
            borderRadius: 5,
            boxShadow: 'inset 2px 2px 2px hsla(0,0%,100%,.25), inset -2px -2px 2px rgba(0,0,0,.25)'
          },
          '&::-webkit-scrollbar-track-piece': {
            background: 'transparent'
          }
        },
        MuiButton: {
          root: {
            borderRadius: 50,
            '&$disabled': {
              '&:hover': {
                cursor: 'not-allowed'
              }
            }
          }
        }
      }
    },
    MuiButton: {
      root: {
        borderRadius: 30,
        textTransform: 'none',
        fontWeight: 700,
        padding: '8px 30px',
        minWidth: 105
      },
      contained: {
        backgroundColor: '#413292',
        textTransform: 'none',
        fontSize: 14,
        color: 'white',
        '&:hover': {
          backgroundColor: 'white',
          color: '#451295'
        }
      }
    },
    MuiOutlinedInput: {
      multiline: {
        paddingTop: 14,
        alignItems: 'baseline'
      },
      inputMultiline: {
        height: '100%'
      }
    }
  }
})
